import { gql } from '@apollo/client';
import { client } from '../../../Utils/graphClients';

export const login = async (variables) => {

  //TODOコピペなので治す
  const query = gql`
    query login($id: String!, $password: String!) {
      login(id: $id, password: $password) {
        message
        token
        __typename
        shops {
          name
          shop_id
        }
      }
    }
  `;

  const res = await client.query({ query, variables });
  console.log('auth.js res', res)
  return res;
};
